<template>
  <v-container fluid class="list-sor">
    <v-row class="flex-grow-0">
      <h3>{{ $t("app_drawer.sor") }}</h3>
      <v-btn
        color="primary"
        class="ml-4"
        small
        v-if="$store.getters.hasPermission(PERMISSIONS.MANAGE_SOR)"
        @click="createSor"
      >
        <v-icon>mdi-plus</v-icon>
        {{ $t("new") }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col>
        <SorList full-height :refresh-trigger.sync="refreshTrigger"></SorList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref } from "@vue/composition-api";
import SorList from "@/components/sor/SorList";
import CreateSorDialog from "@/components/sor/CreateSorDialog";
import { PERMISSIONS } from "@/constants";

export default {
  name: "SoRs",
  components: { SorList },
  setup(props, { root }) {
    const createSor = async function () {
      const sorId = await root.$dialog.showAndWait(CreateSorDialog, {
        showClose: false,
        persistent: true,
      });

      if (sorId) {
        root.$router.push({ name: "sor-detail", params: { sorId } });
      }
    };

    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    return {
      createSor,

      refreshTrigger,
      refresh,

      PERMISSIONS,
    };
  },
};
</script>

<style lang="less">
.list-sor {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
